export function scrollToTop(e?: React.MouseEvent) {
  if (e) e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
} 